export default {
  license: {
    license_manage_title: 'License Management',
    btn_apply: 'Apply for a license',
    btn_import: 'Import license',
    probation_title: 'You are in trial period',
    probation_desc: 'The current software is in trial period, for a smooth use experience, please import a valid license before {date}',
    probation_over_desc: 'Your trial period has expired, please import a valid license',
    upload_format_error: 'Please import the .lic file',
    upload_lic_success: 'Import successful! ',
    upload_lic_fail: 'Import failed! ',
    license_expired: 'The license has expired, please contact the administrator to apply for extenstion',
    license_probation_expired: 'The trial period has expired, please contact the administrator to apply for a license',
    license_popup_title: 'Prompt Information',
    client: {
      client_info_title: 'Customer Information',
      owner: 'License owner',
      status: 'Status',
      id: 'License serial number',
      generate_date: 'Generation date',
      valid_date: 'valid date',
      product: 'Authorized product',
      robot_num: 'Number of authorized robots',
      used_robot: 'Number of used robots',
      authorized_info: 'Authorization Information',
      expired: 'Expired',
      valid: 'Valid',
      open: 'Open',
      close: 'Close',
      faq_amount: 'FAQ number',
      kg_entity: 'KG entity',
      te_scenerio: 'TE scene',
      chat_function: 'Chatting function',
      ner_function: 'NER function',
      function: 'Skill discovery',
      probation_expired: 'The trial period is over',
      probation_valid: 'The trial period is valid',
      license_expired: 'Expired',
      license_valid: 'valid',
      authorized_list_title: 'Authorized product list',
    },
    authorized_status: {
      title: 'Authorized use status',
      robot_used_status: 'Total number of authorized robots {total} {num} used',
      robot_name: 'Robot name',
      robot_num: 'Number of robots',
      user_name: 'Username',
      amount: 'Used amount',
      opened: 'Opened',
      not_open: 'not open',
      used: 'Used',
      not_use: 'Not used',
      concurrent: 'Concurrent number',
      total_file_count: 'Total number of files',
      amount_per_day: 'Maximum number of files per day',
      total_length: 'Total length (h)',
      length_per_day: 'Maximum time per day (h)',
      online_num: 'Number of seats online',
      short_text: 'Short text label',
      long_text: 'Long text label',
      daily_call: 'Number of daily calls',
      tts_num: 'Number of voice recognition',
      asr_num: 'Number of speech synthesis',
    },
    apply: {
      popup_title: 'License Application',
      apply_steps: 'application steps',
      steps: '["1. Click the button to generate the machine code", "2. Send the machine code to your account manager", "3. Takema license administrator will verify the machine code within 3 working days after receiving the machine code After the information, a license is generated and sent to your mailbox", "4. After you check the email, download the license certificate, upload and import it on the BFOP platform"]',
      generate_code: 'Generate machine code',
      generating_code: 'Machine code is being generated',
      generate_success: 'Generate success! ',
      generate_fail: 'Generation failed! ',
      machine_code: 'Machine Code',
      generated_tips: 'The machine code has been generated, please copy/download and send the machine code information to support@emotibot.com, there will be staff processing the email reply progress',
      generated_tips_fail: 'Machine code generation failed, please  try again in ten minutes',
      file_name: 'Authorization code',
      copy_success: 'Copy success',
      empty_code: 'The machine code is empty! ',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/us-en-license.js